export const SET_FORM = 'SET_FORM'
export const SET_FORM_KEY = 'SET_FORM_KEY'
